// 9fbef606107a605d69c0edbcd8029e5d
import {
  FETCH_DY_RECOMMENDATIONS_DATA,
  SET_DY_LOADING_STATE,
  SET_DY_RECOMMENDATIONS_DATA,
  CLEAR_DY_RECOMMENDATIONS_DATA,
  SEND_TRACK_EVENTS_TO_DY,
} from './DyRecommendations.constants';

export const fetchDyRecommendationsData = (payload) => {
  return {
    type: FETCH_DY_RECOMMENDATIONS_DATA,
    payload,
  };
};

export const setDyRecommendationsData = (payload) => ({
  type: SET_DY_RECOMMENDATIONS_DATA,
  payload,
});

export const setLoadingState = (payload) => ({
  type: SET_DY_LOADING_STATE,
  payload,
});

export const clearRecommendationData = (payload) => {
  return {
    type: CLEAR_DY_RECOMMENDATIONS_DATA,
    payload,
  };
};

export const sendTrackEventsToDy = (payload) => ({
  type: SEND_TRACK_EVENTS_TO_DY,
  payload,
});

export default {
  fetchDyRecommendationsData,
};
